import React, { useCallback, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useGetModificationLoanForms from '../../../Hook/Interest/UseGetModificationLoanForms';
import { ModificationLoanForm } from '../../../Interface/Response/Interest/ModificationLoanForm';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import { Filter } from '../../../Enum/Filters';
import { LoanFormName } from '../../../Enum/Filters/LoanForm';

interface Props {
    onSelect: (modificationLoanForm: ModificationLoanForm) => void;
}

const findLoanForm = (
    modificationLoanForms: ModificationLoanForm[],
    loanFormId: string,
    selectedModificationLoanFormName: string,
): ModificationLoanForm => {
    let loanForm = modificationLoanForms.find(
        ({ modificationLoanFormId }) => modificationLoanFormId === parseInt(loanFormId),
    );

    if (loanForm === undefined)
        loanForm = modificationLoanForms.find(({ loanFormName }) => loanFormName === selectedModificationLoanFormName);

    if (loanForm === undefined)
        loanForm = modificationLoanForms.find(({ loanFormName }) => loanFormName === LoanFormName.Annuïtair);

    if (loanForm === undefined) loanForm = modificationLoanForms[0];

    return loanForm;
};

const ModificationLoanFormFilter: React.FC<Props> = ({ onSelect }: Props) => {
    const modificationLoanForms = useGetModificationLoanForms();

    const selectedModificationLoanFormId = useGetFilterValue(Filter.ModificationLoanForm) as string;
    const selectedModificationLoanFormName = useGetFilterValue(Filter.ModificationLoanFormName) as string;

    const selectModificationLoanForm = useCallback(
        (loanFormId: string) => {
            const loanForm = findLoanForm(modificationLoanForms, loanFormId, selectedModificationLoanFormName);

            if (loanForm !== undefined) onSelect(loanForm);
        },
        [modificationLoanForms, onSelect, selectedModificationLoanFormName],
    );

    useEffect(() => {
        if (
            !modificationLoanForms.find(
                ({ modificationLoanFormId }) => modificationLoanFormId === parseInt(selectedModificationLoanFormId),
            )
        ) {
            selectModificationLoanForm(selectedModificationLoanFormId);
        }
    }, [modificationLoanForms, selectedModificationLoanFormId, selectModificationLoanForm]);

    return (
        <Form className="loan-form-filter" autoComplete="off">
            <Form.Group controlId="loan-form">
                <Form.Label>Aflossingsvorm</Form.Label>
                <Form.Control
                    as="select"
                    custom
                    disabled={modificationLoanForms.length === 0}
                    value={selectedModificationLoanFormId}
                    onChange={e => selectModificationLoanForm(e.currentTarget.value)}
                >
                    {modificationLoanForms.map(loanform => (
                        <option value={loanform.modificationLoanFormId} key={loanform.modificationLoanFormId}>
                            {loanform.loanFormName}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Form>
    );
};

export default ModificationLoanFormFilter;
